import React, { useEffect } from "react";
import "./App.css";
import { useAppSelector } from "./utils/redux/hooks";
import { TopNavbar } from "./layouts/topNavBar/TopNavBar";
import Footer from "./layouts/footer/Footer";
import imageWhatsapp from "./assets/whatsapp-logo-green.png";
import MainBody from "./layouts/mainBody/MainBody";
import HomePageVideo from "./components/HomeVideo";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

function App() {
  const theme = useAppSelector((state) => state.theme).value;
  const location = useLocation();
  const { i18n } = useTranslation();

  // Handle language switching from URL query parameter
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const langParam = searchParams.get('lang');
    
    if (langParam && ['it', 'en', 'es'].includes(langParam)) {
      if (i18n.language !== langParam) {
        i18n.changeLanguage(langParam);
      }
    }
  }, [location.search, i18n]);

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.add(theme);

    // Gestione silenziosa degli errori di caricamento risorse esterne
    const handleResourceError = (event: ErrorEvent) => {
      // Ignora errori di risorse esterne (Google Maps, estensioni browser, etc.)
      if (event.message && (
        event.message.includes('googleapis.com') ||
        event.message.includes('ERR_BLOCKED_BY_CLIENT') ||
        event.message.includes('content_script')
      )) {
        event.preventDefault();
        return false;
      }
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      // Ignora errori di caricamento di risorse esterne
      if (event.reason && typeof event.reason === 'string' && (
        event.reason.includes('googleapis.com') ||
        event.reason.includes('ERR_BLOCKED_BY_CLIENT')
      )) {
        event.preventDefault();
        return false;
      }
    };

    window.addEventListener('error', handleResourceError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleResourceError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, [theme]);

  return (
    <div className="text-font-900 font-sans">
      {/* WhatsApp Fixed Button - migliorato per accessibilità */}
      <a
        className="fixed z-50
                   w-[15%] bottom-[5%] right-[5%]
                   sm:w-[12.5%] sm:bottom-[5%] sm:right-[5%]
                   md:w-[10%] md:bottom-[5%] md:right-[5%]
                   lg:w-[7.5%] lg:bottom-[5%] lg:right-[5%]
                   xl:w-[5%] xl:bottom-[5%] xl:right-[5%]
                   focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 rounded-lg"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contattaci su WhatsApp - si apre in una nuova finestra"
        href="https://wa.me/393898226214"
      >
        <img
          src={imageWhatsapp}
          alt="Logo WhatsApp - Contatta Odontoiatria Sgarbini"
          className="drop-shadow-2xl bg-transparent rounded-lg hover:scale-105 transition-transform duration-200"
          loading="lazy"
        />
      </a>

      <main className="flex flex-col drop-shadow-2xl min-h-screen">
        <header
          className="bg-lightbg-headerPrimary text-font-header 
                        text-lg drop-shadow flex-grow-2 flex
                        pt-[0.5%] pb-[0.5%] 
                        pl-[5%] pr-[5%]
                        md:pl-[7%] md:pr-[7%]
                        lg:pl-[1%] lg:pr-[1%]
                        2xl:pl-[9%] 2xl:pr-[9%]
                        justify-between"
          role="banner"
        >
          <TopNavbar />
        </header>

        {/* Video a tutta larghezza senza padding laterali */}
        {location.pathname === "/" && (
          <div className="w-full">
            <HomePageVideo />
          </div>
        )}

        <div className={`text-lg text-pretty text-justify flex flex-col items-center ${location.pathname === "/" ? "" : "bg-lightbg-white pl-[5%] pr-[5%] 2xl:pl-[10%] 2xl:pr-[10%]"}`}>
          <MainBody />
        </div>
        <div className="flex-grow-0 bg-lightbg-darkGrey text-font-footer text-lg pl-[5%] pr-[5%] md:pl-[10%] md:pr-[10%] lg:pl-[15%] lg:pr-[15%] 2xl:pl-[20%] 2xl:pr-[20%]  ">
          <Footer />
        </div>
      </main>
    </div>
  );
}

export default App;
